/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  AuthorRecommendationsControllerCreateMutationRequest,
  AuthorRecommendationsControllerCreateMutationResponse,
  AuthorRecommendationsControllerCreate400,
  AuthorRecommendationsControllerCreate401,
  AuthorRecommendationsControllerCreate429,
} from '../types/AuthorRecommendationsControllerCreate.ts';

function getAuthorRecommendationsCreateUrl() {
  const res = { method: 'POST', url: `/api/author-recommendations` as const };
  return res;
}

/**
 * {@link /api/author-recommendations}
 */
export async function authorRecommendationsCreate(
  data: AuthorRecommendationsControllerCreateMutationRequest,
  config: Partial<RequestConfig<AuthorRecommendationsControllerCreateMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    AuthorRecommendationsControllerCreateMutationResponse,
    ResponseErrorConfig<
      | AuthorRecommendationsControllerCreate400
      | AuthorRecommendationsControllerCreate401
      | AuthorRecommendationsControllerCreate429
    >,
    AuthorRecommendationsControllerCreateMutationRequest
  >({ method: 'POST', url: getAuthorRecommendationsCreateUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
